import { appConfig } from "../config/config";
import api from "./api/api";

export type DDRSubmission = {
  _id: string;
  userId: string;
  name: string;
  documentType: string;
  _createdDate: string;
};

export type DDRPresignedResponse = {
  submissionId: string;
  presignedUrl: string;
  expiresIn: number;
};

export const getDDRHistory = async (): Promise<DDRSubmission[]> => {
  const response = await api.get<DDRSubmission[]>(
    `ddr/${appConfig.tenant}/ddr-submissions`,
  );
  return response;
};

export const getDDRPresignedUrl = async (
  submissionId: string,
): Promise<DDRPresignedResponse> => {
  const response = await api.get<DDRPresignedResponse>(
    `ddr/${appConfig.tenant}/ddr-submissions/${submissionId}/presigned-url`,
  );
  return response;
};
